import { useLazyQuery as l } from "@apollo/client";
import p from "../../../apostle-lib/deserializes/hooks/useMakeApostleMintConfig.js";
import { frontendConfigSchema as c } from "../../deserializes/yup/config.js";
import d from "../../graphql/getFrontendConfig.js";
import { i18nNamespace as g } from "../../../temp-lib/constants/i18n.js";
import { DEFAULT_LOCALE as C } from "../../../temp-lib/constants/locale.js";
import { hyphenLocale as y } from "../../../temp-lib/util/i18n/helper/locale.js";
import * as t from "ramda";
import { useState as h, useCallback as L } from "react";
import { useTranslation as k } from "react-i18next";
const D = () => {
  const [n, { loading: s }] = l(d), { i18n: e } = k(), [a, m] = h(null), { makeApostleMintConfig: i } = p(), u = L(async () => {
    const f = await n(), r = t.path(["data", "getSystemConfig", 0], f);
    if (t.isNil(r))
      return null;
    try {
      const o = c.cast(r);
      return t.isNil(o) ? null : (o.apostleMintConfig = i(r), m(o), t.isNotEmpty(o.i18nLookup) && e.addResourceBundle(
        y(C),
        g.Backend,
        {
          ...o.i18nLookup
        },
        !0,
        !0
      ), o);
    } catch (o) {
      console.error(o);
    }
    return null;
  }, [e, i, n]);
  return {
    data: a,
    loading: s,
    fetch: u
  };
};
export {
  D as default
};
//# sourceMappingURL=useGetFrontendConfig.js.map
